import {
  ChecklistItemsResultEntity,
  ChecklistItemsTabStatus,
} from "../../entities/ChecklistEntity";
import { ChecklistRepository } from "../../repositories/ChecklistRepository";

/**
 * Search checklist items by title within an accounting area (paginated).
 */
export class SearchChecklistItemsUseCase {
  constructor(private repository: ChecklistRepository) {}

  async execute(
    month: string,
    accountingArea: string,
    titleQuery: string,
    offset: number = 0,
    limit: number = 20,
    status?: ChecklistItemsTabStatus | null
  ): Promise<ChecklistItemsResultEntity> {
    return await this.repository.searchItemsByTitleInArea(
      month,
      accountingArea,
      titleQuery,
      offset,
      limit,
      status
    );
  }
}
